"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IGetInboxMessagesParams", {
  enumerable: true,
  get: function get() {
    return messages.IGetInboxMessagesParams;
  }
});
exports["default"] = void 0;

var _client = require("../client");

var _count = require("./count");

var message = _interopRequireWildcard(require("./message"));

var messageLists = _interopRequireWildcard(require("./message-lists"));

var messages = _interopRequireWildcard(require("./messages"));

var _markAllRead = require("./mark-all-read");

var _trackEvent = require("./track-event");

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }

function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }

var _default = function _default(params) {
  var client = (0, _client.createCourierClient)(params, {
    apiUrl: "https://inbox.courier.com/q"
  });
  return {
    addTag: (0, _trackEvent.trackEvent)(client)("addTag"),
    removeTag: (0, _trackEvent.trackEvent)(client)("removeTag"),
    getInboxCount: (0, _count.getInboxCount)(client),
    getMessage: message.getInboxMessage(client),
    getMessageLists: messageLists.getMessageLists(client),
    getMessages: messages.getInboxMessages(client),
    markAllRead: (0, _markAllRead.markAllRead)(client),
    markArchive: (0, _trackEvent.trackEvent)(client)("archive"),
    markOpened: (0, _trackEvent.trackEvent)(client)("opened"),
    markRead: (0, _trackEvent.trackEvent)(client)("read"),
    markUnread: (0, _trackEvent.trackEvent)(client)("unread"),
    trackClick: (0, _trackEvent.trackEvent)(client)("clicked"),
    unpinMessage: (0, _trackEvent.trackEvent)(client)("unpin")
  };
};

exports["default"] = _default;